module.exports = __webpack_public_path__ + "img/baomi.6cc15681.png";